/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Status_ShippedInputs */

const en_status_shipped = /** @type {(inputs: Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shipped`)
};

const es_status_shipped = /** @type {(inputs: Status_ShippedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviado`)
};

/**
* | output |
* | --- |
* | "Shipped" |
*
* @param {Status_ShippedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const status_shipped = /** @type {((inputs?: Status_ShippedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Status_ShippedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_status_shipped(inputs)
	return es_status_shipped(inputs)
});